import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "svgIcon-arrow",
  "use": "svgIcon-arrow-usage",
  "viewBox": "0 0 306 306",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 306 306\" id=\"svgIcon-arrow\"><path d=\"M94.35 0l-35.7 35.7L175.95 153 58.65 270.3l35.7 35.7 153-153z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol